<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailCommande.generalTitle.achat') }}
      </p>
    </header>
    <div class="card-content">
      <information-msg-component title="general.info"
                                 :canClose="false"
                                 v-if="groupeProduitExistant || getAllLigneAPlat.length === 0"
                                 :libelleList="getMessage">
      </information-msg-component>
      <b-table :data="getAllLigneAPlat" :bordered="true" :striped="true"
               v-if="startArrayRendering && getAllLigneAPlat.length > 0">
        <b-table-column field="description" v-slot="props" cell-class="vertical-alignment"
                        :label="$t('detailCommande.achats.description')">
          <span v-html="props.row.description"></span>
        </b-table-column>
        <b-table-column field="totalHt"
                        v-slot="props" cell-class="vertical-alignment has-text-right"
                        :label="$t('detailCommande.achats.montantHt')">
          <div>{{ props.row.totalHt | formatDevise }}</div>
        </b-table-column>
        <b-table-column field="fournisseur"
                        v-slot="props" cell-class="vertical-alignment"
                        :label="$t('detailCommande.achats.fournisseur')">
          {{ props.row.fournisseurId ? props.row.fournisseur.nomCommercial : '' }}
        </b-table-column>
        <b-table-column field="aFacturer"
                        v-slot="props" cell-class="vertical-alignment"
                        :label="$t('detailCommande.achats.aFacturer')"
                        v-if="!afficherReglementDetail">
          <qd-switch disabled v-model="props.row.aFacturer"></qd-switch>
        </b-table-column>
        <b-table-column field="modeReglement"
                        v-slot="props" cell-class="vertical-alignment"
                        :label="$t('detailCommande.achats.modeReglement')"
                        v-else>
          <div>{{ props.row.modeReglementId ? props.row.modeReglement.libelle : '' }}</div>
        </b-table-column>
        <b-table-column field="dateReglement"
                        v-slot="props" cell-class="vertical-alignment"
                        :label="$t('detailCommande.achats.dateReglement')"
                        v-if="afficherReglementDetail">
          {{ props.row.dateReglement | formatDate }}
        </b-table-column>
      </b-table>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import getLigneAPlat from '@/services/dcf/lignesDCF/getLigneAPlat';
import getDescriptionOfDetailLigne from '@/services/devisCommandes/getDescriptionOfDetailLigne';
import informationMsgComponent from '@/components/general/informationMsgComponent';
import * as devisConf from '@/configuration/devisConf';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'detailAchatCommande',
  props: {
    dcf: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      startArrayRendering: false,
    };
  },
  components: {
    informationMsgComponent,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    getAllLigneAPlat() {
      return getLigneAPlat(this.dcf.lignesCommande.filter((ligne) => {
        return !ligne.referencePersonnalise;
      }));
    },
    groupeProduitExistant() {
      return this.dcf.lignesCommande.filter((ligneCommande) => {
        return ligneCommande.referencePersonnalise !== null;
      }).length > 0;
    },
    getMessage() {
      const message = [];
      if (this.groupeProduitExistant) {
        message.push({ libelle: this.$t('detailCommande.achats.message') });
      }
      if (this.getAllLigneAPlat.length === 0) {
        message.push({ libelle: this.$t('detailCommande.achats.messageNoLigne') });
      }
      return message;
    },
    afficherReglementDetail() {
      return this.dcf.type === devisConf.TYPE_FACTURE && this.dcf.sens === devisConf.SENS_VENTE;
    },
  },
  mounted() {
    this.dcf.lignesCommande.forEach((lignesCommande) => {
      if (!lignesCommande.lignesCommande || lignesCommande.lignesCommande.length === 0) {
        lignesCommande.description = getDescriptionOfDetailLigne(
          null, lignesCommande, this.dcf.type, [], false,
        );
        lignesCommande.libelleFournisseur = lignesCommande.fournisseurId ? lignesCommande.fournisseur.nomCommercial : '';
        return;
      }
      let isFirstLigne = true;
      lignesCommande.lignesCommande.forEach((ligneEnfant) => {
        ligneEnfant.description = getDescriptionOfDetailLigne(
          ligneEnfant, lignesCommande, this.dcf.type, [], isFirstLigne,
        );
        isFirstLigne = false;
        ligneEnfant.description = ligneEnfant.description.replaceAll('<br>', ' ');
        ligneEnfant.libelleFournisseur = ligneEnfant.fournisseurId ? ligneEnfant.fournisseur.nomCommercial : '';
      });
    });
    this.startArrayRendering = true;
  },
};
</script>

<style scoped>

</style>
